
import { RouteObject } from 'react-router-dom';
import ProductsPage from '../pages/products/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <ProductsPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
